export const HUBSPOT_CONTACT_OBJECT_TYPE = 'contacts';
export const HUBSPOT_COMPANY_OBJECT_TYPE = 'companies';

export const PRIMARY_COMPANY_ASSOCIATION_TYPE_ID = 1;
